import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Toaster } from "sonner";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

export default function AdminContent() {
  const nav = useNavigate();
  const [tab, setTab] = useState("stories");
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get(`/admin/${tab === "stories" ? "patient-stories" : tab}`);
      setItems(data);
    } catch { nav("/admin/login"); }
  };

  useEffect(() => { if (!localStorage.getItem("hc_admin_token")) nav("/admin/login"); else load(); }, [tab]);

  const togglePublish = async (id, field, value) => {
    const endpoint = tab === "stories" ? "patient-stories" : tab;
    try {
      await api.patch(`/admin/${endpoint}/${id}`, { [field]: value });
      toast.success("Updated");
      load();
    } catch { toast.error("Failed"); }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Toaster richColors position="top-center" />
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-3.5 flex items-center justify-between">
          <Link to="/admin/dashboard" className="inline-flex items-center gap-1.5 text-[#0369A1] font-medium text-sm"><ArrowLeft size={16} /> Dashboard</Link>
          <div className="font-serif font-semibold text-slate-900">Content Management</div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-wrap gap-2 mb-5">
          {["stories"].map((t) => (
            <button key={t} data-testid={`tab-${t}`} onClick={() => setTab(t)} className={`px-4 py-2 rounded-lg text-[14px] font-medium border ${tab === t ? "bg-[#0369A1] text-white border-[#0369A1]" : "bg-white border-slate-200 text-slate-700"}`}>
              {t.charAt(0).toUpperCase() + t.slice(1)}
            </button>
          ))}
        </div>

        <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
          <table className="w-full text-[14px]">
            <thead className="bg-slate-50 text-slate-600 text-[12px] uppercase tracking-wider">
              <tr>
                <th className="text-left p-3">Name</th>
                <th className="text-left p-3 hidden md:table-cell">City</th>
                <th className="text-left p-3 hidden lg:table-cell">Created</th>
                <th className="text-left p-3">Verified</th>
                <th className="text-left p-3">Published</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.id} data-testid={`content-row-${it.id}`} className="border-t border-slate-100">
                  <td className="p-3 font-medium text-slate-900">{it.name || it.patient_name}</td>
                  <td className="p-3 hidden md:table-cell">{it.city || "—"}</td>
                  <td className="p-3 hidden lg:table-cell text-slate-500">{it.created_at?.slice(0, 10)}</td>
                  <td className="p-3">
                    {tab !== "stories" && (
                      <button onClick={() => togglePublish(it.id, "verified", !it.verified)} className={`chip ${it.verified ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-600"}`}>
                        {it.verified ? <><CheckCircle2 size={12} /> Verified</> : "Unverified"}
                      </button>
                    )}
                    {tab === "stories" && <span className="text-slate-400">—</span>}
                  </td>
                  <td className="p-3">
                    <button data-testid={`toggle-publish-${it.id}`} onClick={() => togglePublish(it.id, "published", !it.published)} className={`chip ${it.published ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>
                      {it.published ? "Published" : "Draft"}
                    </button>
                  </td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-slate-500">No items yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
